// Copyright 2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import { MultiCheckbox } from "./MultiCheckbox";

export default MultiCheckbox;
